"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const DataLayerEvents_1 = __importDefault(require("../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const dataLayer_1 = require("../helper/dataLayer");
const ContactLink = ({ dataLayerClickType, dataLayerTitle, href, icon, label, sendDataLayerLabel, }) => (react_1.default.createElement("div", { className: "d-flex flex-row align-items-center" },
    icon ? react_1.default.createElement(Icon_1.default, { name: icon, className: "znd-contact-person__icon" }) : null,
    react_1.default.createElement("a", { target: "_blank", rel: "noreferrer", href: href, title: label, className: "znd-contact-person__link", onClick: () => {
            let data = {
                event: DataLayerEvents_1.default.dlvContactPerson,
                [DataLayerLabels_1.default.dlvContactPersonClickType]: dataLayerClickType,
                [DataLayerLabels_1.default.dlvContactPersonTitle]: dataLayerTitle,
            };
            if (sendDataLayerLabel) {
                data = { ...data, ...{ [DataLayerLabels_1.default.dlvKontaktanfrageOpenValue]: label } };
            }
            (0, dataLayer_1.pushToDataLayer)(data);
        } }, label)));
exports.default = ContactLink;
